import { useEffect, useRef } from "react";
import { roomCodeFromFragment } from "../../../packages/session-code/src";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import { Button } from "./components/Button";
import { useUiText } from "./i18n/useUiText";
import { CreateScreen } from "./screens/CreateScreen";
import { HandScreen } from "./screens/HandScreen";
import { HistoryScreen } from "./screens/HistoryScreen";
import { HomeScreen } from "./screens/HomeScreen";
import { JoinScreen } from "./screens/JoinScreen";
import { RevealScreen } from "./screens/RevealScreen";
import { RoomScreen } from "./screens/RoomScreen";
import { SeatScreen } from "./screens/SeatScreen";
import { ThemeScreen } from "./screens/ThemeScreen";
import { useAppStore } from "./state/useAppStore";

function ErrorFallback() {
  const t = useUiText();
  return (
    <main className="fatal-error">
      <div className="fatal-error__panel" role="alert">
        <p className="eyebrow">{t("app.title")}</p>
        <h1>{t("error.boundaryTitle")}</h1>
        <p>{t("error.boundaryBody")}</p>
        <Button onClick={() => window.location.reload()}>
          {t("error.reload")}
        </Button>
      </div>
    </main>
  );
}

function ActiveScreen() {
  const screen = useAppStore((state) => state.screen);
  const session = useAppStore((state) => state.session);
  const joinSession = useAppStore((state) => state.joinSession);
  const fragmentImportAttempted = useRef(false);

  useEffect(() => {
    if (fragmentImportAttempted.current || session !== null) return;
    fragmentImportAttempted.current = true;
    const code = roomCodeFromFragment(window.location.hash);
    if (code === null) return;
    window.history.replaceState(
      null,
      "",
      `${window.location.pathname}${window.location.search}`
    );
    void joinSession(code);
  }, [joinSession, session]);

  switch (screen) {
    case "home":
      return <HomeScreen />;
    case "create":
      return <CreateScreen />;
    case "join":
      return <JoinScreen />;
    case "room":
      return <RoomScreen />;
    case "seat":
      return <SeatScreen />;
    case "theme":
      return <ThemeScreen />;
    case "hand":
      return <HandScreen />;
    case "reveal":
      return <RevealScreen />;
    case "history":
      return <HistoryScreen />;
  }
}

export function App() {
  return (
    <AppErrorBoundary fallback={<ErrorFallback />}>
      <ActiveScreen />
    </AppErrorBoundary>
  );
}
